// src/components/NavBar.tsx
import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Stack, IconButton, Drawer, List, ListItem, ListItemText, ListItemButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

const NavBar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const menuItems = [
    { text: 'Home', link: '/' },
    { text: 'Instructions', link: '/instructions' },
    { text: 'About', link: '/about' },
    { text: 'Contact', link: '/contact' },
  ];

  return (
    <AppBar position="static" style={{ backgroundColor: 'beige', boxShadow: 'none' }}>
      <Toolbar style={{ justifyContent: 'space-between' }}>
        {/* Title on the top left */}
        <Typography variant="h4" component="div" style={{ fontWeight: 'bold', color: '#001f3f' }}>
          Full Focus
        </Typography>
        
        {/* Desktop Buttons on the top right */}
        <Stack direction="row" spacing={2} sx={{ display: { xs: 'none', md: 'flex' } }}>
          {menuItems.map((item) => (
            <Button
              key={item.text}
              component={Link}
              to={item.link}
              style={{ color: '#001f3f', border: 'none', textTransform: 'none' }}
            >
              {item.text}
            </Button>
          ))}
        </Stack>

        {/* Mobile Menu Icon */}
        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
          sx={{ display: { xs: 'flex', md: 'none' }, color: '#001f3f' }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Drawer for Mobile Menu */}
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List style={{ width: 250 }}>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton component={Link} to={item.link} onClick={toggleDrawer(false)}>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default NavBar;
